// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3DCLs","rootSuccess":"CompleteLink_rootSuccess__1Vcbi","rootFailure":"CompleteLink_rootFailure__2uOLl","isDisabled":"CompleteLink_isDisabled__33QJn"};